import { Preferences } from '@capacitor/preferences'
import type { RoastTone } from './roasts'

const KEY = 'tabofshame.lastRoast.v1'

export type LastRoast = {
  text: string
  tone: RoastTone
  savedAt: number
}

const TONES: RoastTone[] = ['cheap', 'standard', 'generous', 'extra', 'habit', 'navigator']

function isLastRoast(value: unknown): value is LastRoast {
  if (!value || typeof value !== 'object') return false
  const row = value as LastRoast
  return (
    typeof row.text === 'string' &&
    row.text.length > 0 &&
    TONES.includes(row.tone) &&
    typeof row.savedAt === 'number'
  )
}

export async function loadLastRoast(): Promise<LastRoast | null> {
  try {
    const { value } = await Preferences.get({ key: KEY })
    if (!value) return null
    const parsed: unknown = JSON.parse(value)
    return isLastRoast(parsed) ? parsed : null
  } catch {
    return null
  }
}

export async function saveLastRoast(text: string, tone: RoastTone): Promise<void> {
  const payload: LastRoast = { text, tone, savedAt: Date.now() }
  await Preferences.set({ key: KEY, value: JSON.stringify(payload) })
}
